import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../environments/environment';

@Pipe({
  name: 'pdf',
})
export class PdfPipe implements PipeTransform {
  url: string = environment.apiURL;

  transform(value: unknown, ...args: unknown[]): string {
    return `${this.url}pdf/${value}`;
  }
}
